//src/app/features/questionnaires/create/useCreateQuestionnaireForms.tsx
import TaxQuestionnaire from '../edit/TaxQuestionnaire';
import PrepareQuestionnaire from './PrepareQuestionnaire';
import TaxRequestTarget from './TaxRequestTarget';

export default function useCreateQuestionnaireForms() {
  return [
    <TaxRequestTarget key={0} stepName="taxRequestTarget" />,
    <PrepareQuestionnaire key={1} stepName="prepareQuestionnaire" />,
    <TaxQuestionnaire key={1} stepName="taxQuestionnaire" />,
  ];
}
